import { PriceOfferRow } from 'components/tables/data/price-offer/types';
import P2Regular from 'components/typography/P2Regular';

type PriceField = 'finalPrice' | 'finalPriceLabor' | 'finalPriceMaterial';

/**
 * Column for the final price.
 */
export default function FinalPriceColumn({ data, field = 'finalPrice' }: { data: PriceOfferRow; field?: PriceField }) {
  const finalPrice = data[field];

  if (typeof finalPrice !== 'number') {
    return null;
  }

  return (
    <P2Regular color="gray.8">
      {finalPrice.toLocaleString('sk-SK', { minimumFractionDigits: 2, style: 'currency', currency: 'EUR' })}
    </P2Regular>
  );
}
